export const devices = {
    mobileS: "320px",
    mobileM: "375px",
    mobileL: "425px",
    tablet: "767px",
    laptop: "1024px",
    laptopL: "1440px",
    desktop: "2560px",
} as const;
